/**
 * Format today's date according to a format pattern, for the live preview
 * beside the Date Format dropdown.
 *
 * Supports: DD/MM/YYYY, MM/DD/YYYY, YYYY-MM-DD, DD-MMM-YYYY.
 *
 * @param format - The date format pattern, or null/undefined to fall back to DD/MM/YYYY
 * @returns Today's date rendered in that format
 */
export function formatDatePreview(format: string | null | undefined): string {
  const now = new Date();
  const day = String(now.getDate()).padStart(2, '0');
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const year = now.getFullYear();
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const monthShort = monthNames[now.getMonth()];

  switch (format) {
    case 'DD/MM/YYYY':
      return `${day}/${month}/${year}`;
    case 'MM/DD/YYYY':
      return `${month}/${day}/${year}`;
    case 'YYYY-MM-DD':
      return `${year}-${month}-${day}`;
    case 'DD-MMM-YYYY':
      return `${day}-${monthShort}-${year}`;
    default:
      // Default to DD/MM/YYYY if no format specified
      return `${day}/${month}/${year}`;
  }
}
